<template>
    <div class="relative z-10 bg-inherit gap-4 tiptap ProseMirror container ">
        <div class="lg:col-start-2 col-span-full md:col-span-7">
            <h2 v-if="largeTitle" :id="headingId" class="view-h2 col-span-2">{{ get_localized_value(content?.title) }}</h2>
            <h3 v-else :id="headingId" class="view-h3 col-span-2">{{ get_localized_value(content?.title) }}</h3>
        </div>
        <div class="col-span-full md:col-span-8 lg:col-start-2 lg:col-end-11">
            <RenderedHTML :value="content?.['body']"></RenderedHTML>
        </div>
    </div>
</template>

<script lang="ts" setup>
import RenderedHTML from "~/components/view/RenderedHTML.vue"
const {get_value: get_localized_value} = useLocalizedValue()

const { content, headingId } = defineProps({
    content: {
        type: Object
    },
    image: {
        required: false,
        type: String
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    },
    headingId: String,
    largeTitle: {
        type: Boolean,
        default: false
    }
})


</script>
